import { Colors, Text } from '@mercator-gcp/grout';
import InfoMarker from 'components/elements/InfoMarker';
import SearchInput from 'components/elements/SearchInput';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { useKeywordFilter } from 'state/filterDocuments';

const DISABLED_TOOLTIP =
  'Keyword search is disabled because your other filters return more than 2.5 million filings. Narrow your other filters to enable it.';

const wrapperStyle = {
  gap: 'padding_4',
  width: '100%',
};

const labelRowStyle = {
  gap: 'padding_4',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

const searchInputStyle = {
  boxShadow: '0px 8px 16px 0px #0000001F',
  height: '48px',
};

interface KeywordFilterProps {
  disabled?: boolean;
}

const KeywordFilter = ({ disabled }: KeywordFilterProps) => {
  const { keywordFilter, setKeywordFilter } = useKeywordFilter();

  return (
    <FlexColumn sx={wrapperStyle}>
      <FlexRow sx={labelRowStyle}>
        <Text.SmallLabel>Keyword</Text.SmallLabel>
        {disabled && (
          <>
            <Text.SmallLabel color={Colors.SystemColorWarning}>
              (disabled)
            </Text.SmallLabel>
            <InfoMarker label={DISABLED_TOOLTIP} />
          </>
        )}
      </FlexRow>
      <SearchInput
        placeholder="Search by keyword"
        value={keywordFilter}
        onChange={setKeywordFilter}
        disabled={disabled}
        sx={searchInputStyle}
      />
    </FlexColumn>
  );
};

export default KeywordFilter;
